import { useState } from 'react';

import { Paper, Tab, Tabs, Box } from '@cast/design-system';

import { NetworkCostSection } from './NetworkCostSection';
import { NetworkTrafficSection } from './NetworkTrafficSection';
import { NetworkResourceType } from '../_types';

export const ChartSection = () => {
  const [activeTab, setActiveTab] = useState<'costs' | 'traffic'>('costs');
  return (
    <Box position="relative">
      <Tabs
        variant="card"
        size="small"
        value={activeTab}
        onChange={(_, tab) => setActiveTab(tab)}
      >
        <Tab
          label="Network costs"
          value={NetworkResourceType.COSTS}
          testId="network-cost-tab"
        />
        <Tab
          label="Network traffic"
          value={NetworkResourceType.TRAFFIC}
          testId="network-traffic-tab"
        />
      </Tabs>

      <Paper sx={{ borderTopLeftRadius: 0 }} data-hc="success">
        {activeTab === 'costs' && <NetworkCostSection />}

        {activeTab === 'traffic' && <NetworkTrafficSection />}
      </Paper>
    </Box>
  );
};
